export default __webpack_public_path__ + "static/media/Disco_Bloodbath_LE.48644eea.jpg";